<nb-card>
  <div class="summary">
    <div class="item">
      <div class="avatar">
        <ngx-view-user-display
          [user]="userData"
          [mode]="'avatar'"
        ></ngx-view-user-display>
      </div>

      <div>
        <ngx-view-user-display
          [user]="userData"
          [mode]="'name'"
        ></ngx-view-user-display>
        <ngx-view-time-ago
          [currentDate]="userData.updatedOn"
        ></ngx-view-time-ago>

        <nb-actions size="none">
          <nb-action *ngIf="mode === 'hearts'">
            <nb-icon status="danger" icon="heart-outline"></nb-icon>
            <span> {{ userData.hearts | number }} </span>
          </nb-action>

          <nb-action *ngIf="mode === 'stars'">
            <nb-icon status="warning" icon="star-outline"></nb-icon>
            <span> {{ userData.stars | number }} </span>
          </nb-action>

          <nb-action *ngIf="mode === 'noLiked'">
            <i
              class="fas fa-thumbs-up"
              style="color: #0095ff; margin-right: 0.5rem"
            ></i>
            <span> {{ userData.noLiked | number }} </span>
          </nb-action>
        </nb-actions>
      </div>
    </div>
  </div>
</nb-card>
